module.exports = __webpack_public_path__ + "static/media/team-5.a9f38cb4.webp";